import { useTranslation } from 'react-i18next';
import "../styles/guildline_page/guildline_page.css";

export default function GuildlinePage() {
    const { t } = useTranslation();
    return (
        <div className="guildline" id="how-it-works">
            <div className="container">
                <div className="contain">
                    <div className="content">
                        <div className="head_text">
                            <div className="head">
                                <h3>{t('how-it-works')}</h3>
                            </div >
                            <p>{t('how-it-works-description')}</p>

                        </div >
                    </div >

                </div >

            </div >
            <div className="main-container">
                <div className="contains">
                    <div className="contain">
                        <div className="head_text">
                            <div className="head">
                                <h3>{t('first-step')} <span>{t('first-step-text')}</span></h3>
                            </div>
                            <p>{t('first-step-description')}</p>
                        </div>
                    </div>
                    <div className="sample">
                        <img src="/assets/step-1.png" alt="Step 1" />
                    </div>
                </div>
                <div className="contains">
                    <div className="contain">
                        <div className="head_text">
                            <div className="head">
                                <h3>{t('second-step')} <span>{t('second-step-text')}</span></h3>
                            </div>
                            <p>{t('second-step-description')}</p>

                        </div>
                    </div>
                    <div className="sample">
                        <img src="/assets/step-2.png" alt="Step 2" />
                    </div>
                </div >
                <div className="contains">
                    <div className="contain">
                        <div className="head_text">
                            <div className="head">
                                <h3>{t('thirth-step')}  <span>{t('thirth-step-text')} </span></h3>
                            </div>
                            <p>{t('thirth-step-description')} </p>

                        </div>
                    </div>
                    <div className="sample">
                        <img src="/assets/step-3.png" alt="Step 3" />
                    </div>
                </div >
            </div >
        </div >
    );
}